import { Card, Empty } from "antd";
import { useNavigate } from "react-router-dom";
import BarList from "./BarList";
import { STAGE_META, INK, compactAmount, fullAmount } from "../crmDashboardUtils";

const titleCase = (s) => String(s || "").charAt(0).toUpperCase() + String(s || "").slice(1);

const PipelineCard = ({ pipeline = [], kpis = {}, currency, country }) => {
  const navigate = useNavigate();
  const hasDeals = pipeline.some((p) => p.count > 0);

  // Bars compare deal value; if nothing has a value yet, compare counts.
  const byValue = pipeline.some((p) => p.value > 0);

  const rows = pipeline.map((p) => {
    const meta = STAGE_META[p.stage] || { label: titleCase(p.stage), color: STAGE_META.negotiation.color };
    return {
      key: p.stage,
      label: `${meta.label}`,
      value: byValue ? p.value : p.count,
      display: `${compactAmount(p.value, country)} ${currency}`,
      secondary: `${p.count} deal${p.count === 1 ? "" : "s"}`,
      color: meta.color,
    };
  });

  return (
    <Card className="crm-card" variant="borderless">
      <div className="crm-card-head">
        <div>
          <div className="crm-card-title">Deal pipeline</div>
          <div className="crm-card-sub">
            <span title={`${fullAmount(kpis.pipeline_value)} ${currency}`}>
              <b className="crm-card-figure">{compactAmount(kpis.pipeline_value, country)}</b> {currency}
            </span>{" "}
            open across {kpis.open_deals || 0} deal{Number(kpis.open_deals) === 1 ? "" : "s"}
          </div>
        </div>
      </div>

      {!hasDeals ? (
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No deals yet" style={{ padding: "32px 0" }} />
      ) : (
        <BarList rows={rows} onRowClick={() => navigate("/crm/deals")} />
      )}

      {hasDeals && (
        <div className="crm-card-foot">
          <span style={{ color: INK.secondary }}>
            Win rate{" "}
            <b>{kpis.win_rate === null || kpis.win_rate === undefined ? "—" : `${kpis.win_rate}%`}</b>
          </span>
          <span style={{ color: INK.secondary }}>
            Avg won deal <b>{compactAmount(kpis.avg_deal_size, country)} {currency}</b>
          </span>
        </div>
      )}
    </Card>
  );
};

export default PipelineCard;
